export default __webpack_public_path__ + "static/media/gallery_20.fa739ad0.jpg";